<div class="d-lg-block d-none">
  <fgb-banner [title]="'rewards.wallet.text' | translate"></fgb-banner>
</div>

<div class="d-block d-lg-none">
  <div class="py-2 bg-primary">
    <fgb-barcode [jetsCashDesign]="true" [isWalletPage]="true" [showMobilePass]="false"></fgb-barcode>
  </div>
</div>

<div class="d-none d-lg-block">
  <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
</div>

<div class="widget-mobile wallet-container">
  <ng-container *ifScreenSize="screenType.Desktop"
    ><fgbcl-campaigns-offers-list [showAllOffers]="false"></fgbcl-campaigns-offers-list
  ></ng-container>

  <ng-container *ngIf="walletItems$ | async as walletItems"
    ><ng-container *ngIf="walletItems?.length > 0; else noWalletItems">
      <div class="wallet-redeem-carousel pt-2 pt-lg-4">
        <div class="container">
          <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
        </div>
      </div> </ng-container
  ></ng-container>

  <ng-container *ifScreenSize="screenType.Mobile"
    ><fgbcl-campaigns-offers-list [showAllOffers]="false"></fgbcl-campaigns-offers-list
  ></ng-container>

  <ng-template #noWalletItems>
    <div class="container">
      <h5 class="no-wallet-items mt-3 mb-3 fw-bold">{{ 'rewards.wallet.no.items' | translate }}</h5>
      <div class="border border-disabled rounded bg-white">
        <div class="no-wallet-items-description fw-bold font-size-12 text-center py-3">
          {{ 'rewards.wallet.no.items.description' | translate }}
        </div>
      </div>
    </div>
  </ng-template>

  <div class="container pt-5 pb-4">
    <div class="history-container">
      <div class="history">
        <h5 class="title font-page-heading text-uppercase">{{ 'redemption.history.title' | translate }}</h5>
        <p class="description font-size-14 mb-0">{{ 'redemption.history.description' | translate }}</p>
      </div>
      <a class="font-size-14 claimed-text fw-bold text-center" [routerLink]="['/rewards/claimed']">
        {{ 'rewards.wallet.view.claimed' | translate }}
      </a>
    </div>
  </div>
</div>
